import request from './request';

export function getGiftList() {
  return request.get('/api/gift/index');
}

export function sendLiveGift(roomId, giftId, giftCount = 1) {
  return request.post('/api/live_gift/send', {
    room_id: roomId,
    gift_id: giftId,
    gift_count: giftCount
  });
}

export function getRecentLiveGifts(roomId, afterId = 0) {
  return request.get('/api/live_gift/recent', { params: { room_id: roomId, after_id: afterId } });
}
